/* Lista de deseados a medida (localStorage) + cajón lateral. Sin apps. */
(function () {
  var KEY = 'an_wishlist_v1';

  function get() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function store(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} updateCounts(); }
  function has(h) { return get().indexOf(h) > -1; }
  function toggle(h) {
    var a = get(), i = a.indexOf(h);
    if (i > -1) a.splice(i, 1); else a.push(h);
    store(a);
    return a.indexOf(h) > -1;
  }

  function updateCounts() {
    var n = get().length;
    document.querySelectorAll('[data-an-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? '' : 'none';
    });
  }
  function markHearts() {
    document.querySelectorAll('.an-heart[data-handle]').forEach(function (b) {
      b.classList.toggle('is-activo', has(b.getAttribute('data-handle')));
    });
  }

  var HEART = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M12 20.3l-1.4-1.3C5.4 14.3 2 11.2 2 7.5 2 4.9 4 3 6.5 3c1.5 0 3 .7 3.9 1.9L12 6.5l1.6-1.6C14.5 3.7 16 3 17.5 3 20 3 22 4.9 22 7.5c0 3.7-3.4 6.8-8.6 11.5L12 20.3z"/></svg>';

  function money(cents, currency) {
    try { return (cents / 100).toLocaleString('es-CO', { style: 'currency', currency: currency || 'COP', minimumFractionDigits: 0 }); }
    catch (e) { return '$' + (cents / 100); }
  }
  function imgUrl(u) {
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=600';
  }
  function cardHtml(p, h) {
    var oferta = p.compare_at_price && p.compare_at_price > p.price;
    return '<div class="an-prod-card">' +
        '<div class="an-prod-card__media">' +
          '<button type="button" class="an-heart is-activo" data-handle="' + h + '" aria-label="Quitar de mis deseados">' + HEART + '</button>' +
          '<a href="/products/' + h + '" class="an-prod-card__media-link">' + (p.featured_image ? '<img src="' + imgUrl(p.featured_image) + '" alt="" loading="lazy">' : '') + '</a>' +
          (p.available ? '' : '<div class="an-prod-card__badges"><span class="an-badge an-badge--agotado">Agotado</span></div>') +
        '</div>' +
        '<a href="/products/' + h + '" class="an-prod-card__info">' +
          '<h3 class="an-prod-card__nombre">' + p.title + '</h3>' +
          '<div class="an-prod-card__precios"><span class="an-prod-card__precio">' + money(p.price, p.currency) + '</span>' +
          (oferta ? '<span class="an-prod-card__precio-tachado">' + money(p.compare_at_price, p.currency) + '</span>' : '') + '</div>' +
        '</a>' +
      '</div>';
  }

  function renderWishlist() {
    var grids = document.querySelectorAll('[data-an-wishlist-grid]');
    if (!grids.length) return;
    var empties = document.querySelectorAll('[data-an-wishlist-empty]');
    var handles = get();
    grids.forEach(function (g) { g.innerHTML = ''; });
    if (!handles.length) { empties.forEach(function (e) { e.style.display = ''; }); return; }
    empties.forEach(function (e) { e.style.display = 'none'; });
    handles.forEach(function (h) {
      fetch('/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { if (!p) return; var html = cardHtml(p, h); grids.forEach(function (g) { g.insertAdjacentHTML('beforeend', html); }); });
    });
  }

  function openDrawer() {
    var d = document.querySelector('[data-an-wishlist-drawer]');
    if (!d) return;
    renderWishlist();
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer() {
    var d = document.querySelector('[data-an-wishlist-drawer]');
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    // abrir / cerrar cajón
    if (e.target.closest('[data-an-wishlist-open]')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-an-wishlist-close]')) { closeDrawer(); return; }
    // corazón: guardar/quitar
    var b = e.target.closest('.an-heart[data-handle]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var on = toggle(b.getAttribute('data-handle'));
    b.classList.toggle('is-activo', on);
    b.classList.add('an-heart--pop');
    setTimeout(function () { b.classList.remove('an-heart--pop'); }, 300);
    if (!on) {
      var card = b.closest('.an-prod-card');
      if (card && card.closest('[data-an-wishlist-grid]')) {
        card.remove();
        if (get().length === 0) renderWishlist();
      }
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  // Permite re-sincronizar corazones tras inyectar tarjetas nuevas (recomendados).
  window.anWishlistSync = markHearts;

  function init() { updateCounts(); markHearts(); }
  if (document.readyState !== 'loading') init();
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function () { markHearts(); });
})();
